import $ from 'jquery';
window.addEventListener('px-ready',function(){
    $(window).on('scroll resize',function(){
        $('[px-scrollspy]').each(function(){
            if($(this).isInViewport()){
               $(this).addClass($(this).attr('px-scrollspy')); 
            }
        })
    })
    $.fn.isInViewport = function() {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        return elementBottom > viewportTop && elementTop < viewportBottom;
    };
});